'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 153 104",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D3D3D3",
    d: "m1 102.102 48.388.898h51.87L153 101.511 109.887 77l-77.04 5.988z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#C1C1C1",
    d: "m49 104 26.42-10.757L101 104 76.123 90z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    d: "M31.718 59.142 0 102.1l28.988-11.43L48.746 103l26.647-12.33L101 103l-9.281-42.838-16.457-3.781-15.321 3.58L48.485 55z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E5F0F8",
    d: "M33.084 59.875 4 100.058l26.047-10.514L49.597 102l26.24-12.618L101 101.333l-8.64-40.36-16.633-3.843-15.45 3.611L49.21 56z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    opacity: 0.35,
    d: "M30 89.544 49.017 56 60 60.741 49.402 102zM76.109 90.104 76 58l16.454 3.825L101 102z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    d: "M92 60.153 101.23 103l21.27-13.485 30.5 11.992-30.5-42.638L106.2 55z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E5F0F8",
    d: "M92 61.063 100.614 101l21.468-12.93L150 99.018l-28.208-39.264L106.36 56z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#F7B731",
    d: "m16 83.489 20.749-6.222L52.346 89l14.11-5.185L69 59l-1.573.374L65.01 82.44l-12.227 4.49-15.067-11.387-20.272 5.91zM68.221 71.16l7.058-3.06 20.068 9.034 2.684-1.567-3.786-15.03L95.787 60 100 76.548 95.735 79 75.28 69.936 68 73.232zM100.423 76.926l12.328-8.282 3.076.984 10.112 20.55L128 91l-11.17-22.4-4.866-1.6L100 75.22z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#F7B731",
    d: "m85 75 1.909 20.146L89 96l-2.2-20.3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#B2B2B2",
    d: "m19.701 78.461 12.141-3.719 8.59-16.507.961-.235-8.33 16.544 5.914-1.65L51 81.144l-5.48 18.74-.038.116-.799-.517 5.388-17.967-11.433-7.828L19 79.444z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#20BF6B",
    opacity: 0.31,
    d: "M128.835 91.57 118 69l12.701 3.715L150 100z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#20BF6B",
    opacity: 0.31,
    d: "M130.204 89.538 121 71l11.258 3.092L149 97z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#B2B2B2",
    d: "m97.993 59 3.355 11.303 8.964-5.862 17.952 4.439.736 1.01-18.185-4.439L100.701 72 97 59.345z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#B2B2B2",
    d: "M87.667 60.217 89.199 72.1l-8.937-3.619v17.361l18.624 8.65 19.888-12.665 3.603 1.742.623 1.242-3.684-1.88L99.212 96 79 86.517V66.829l8.807 3.676L86.72 60z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#99C6E3",
    d: "M36.883 78 41 80.973 37.133 88 33 84.923zM41.458 81 48 85.893 46.375 91 39 85.645zM87 70l-8-3.32V63l7.678 3.328zM87 65l-8-3.302V58l7.696 3.22z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#20BF6B",
    opacity: 0.31,
    d: "m76 58 .06 9.971L78 69l-.096-10.382z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#99C6E3",
    d: "M41.884 58.529 45 58l-1.975 3.653L40 62zM81 73l3.286 1.607L85 87l-4-1.989z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#20BF6B",
    opacity: 0.31,
    d: "m76 86 10.672 5.195L87 95l-10.988-5.446zM75.987 86 50.71 97.913l-3.557-2.04L46 99.704 49.642 102 76 89.45z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#99C6E3",
    d: "M99 59.193 100.515 64 107 60.92 105.37 57zM99.768 93 105 89.7l-2.444-6.7L98 85.864zM104 83.11l2.325 6.89L110 87.538 107.228 81zM60.38 64.476 56 83l4.579-1.845L63 64z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E5F0F8",
    d: "m57 78 5-2.067V75l-4.777 1.901zM59 69.652 63 69v.326L59 70z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#20BF6B",
    opacity: 0.31,
    d: "m21 77 6.7-1.945L37 60l-3.948.917zM30.111 79.409 35 78l-6.753 12.764L23 93z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#99C6E3",
    d: "M41 73.034 50.678 80 52 76.274 42.611 70z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    opacity: 0.35,
    d: "m106 56 15.852 32.056L150 99l-28.44-39.248z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    opacity: 0.4,
    d: "M30 89.544 49.017 56 60 60.741 49.402 102zM76 58l.109 32.104L101 102l-8.546-40.175z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    opacity: 0.3,
    d: "m106 56 15.852 32.056L150 99l-28.44-39.248z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#99C6E3",
    d: "m12 95 6-2.205L24 82l-4.66 1.153z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E5F0F8",
    d: "M14 88.824 23 86l-.631 1.411L14.375 90z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#99C6E3",
    d: "M69.237 74.158 74 72v4.952L69 79z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M61.943 47.337A15.563 15.563 0 0 0 64 39.578C64 30.974 57.06 24 48.5 24 39.937 24 33 30.974 33 39.578a15.577 15.577 0 0 0 1.95 7.572c.416.747.892 1.457 1.423 2.124L48.198 67l12.146-17.37a15.588 15.588 0 0 0 1.604-2.293h-.005Z",
    fill: "#4C9BCE"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    fill: "#F4F4F4",
    cx: 48,
    cy: 38,
    r: 11
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M55.858 37.676a.274.274 0 0 1-.099 0 .95.95 0 0 1-.42-.247H55.3c-.118-.012-.203-.111-.191-.222l-.027-.025c-.156.175-.524.07-.47-.182H41v5h15v-4.299a.28.28 0 0 1-.142-.025Z",
    fill: "#B8BFC9"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E5E7E6",
    d: "M41 41.767h15v1H41z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E0D8D6",
    d: "M41 36.824h16v1H41z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#C8D1E0",
    d: "M41 37h7v5h-7z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#AF7545",
    d: "M49 38h2v3h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D6D6D6",
    d: "M49 37.79h1v1h-1zM49 39h1v2h-1z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#AF7545",
    d: "M51 38h2v3h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D6D6D6",
    d: "M52 37.79h1v1h-1zM52 39h1v2h-1z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#AF7545",
    d: "M53 38h2v3h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D6D6D6",
    d: "M54 37.79h1v1h-1zM54 39h1v2h-1z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#BCBCBC",
    d: "M46.576 41.593v-.309h-.491V41h-3.4v.284h-.262v.309H42V42h5v-.407z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D0D8E2",
    d: "M43 38h3v4h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#A5ACB5",
    d: "M43 38h2v4h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#B8BFC9",
    d: "M56 37.817V37h-1.787l-.213.409 1.885.591z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#6F7575",
    d: "m41 37 3.538-3h7.89L56 37z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M119.94 47.335c3.728-6.524 2.284-14.794-3.431-19.652a15.44 15.44 0 0 0-19.851-.139c-5.783 4.778-7.342 13.026-3.705 19.602.413.745.885 1.454 1.412 2.122L106.19 67l12.15-17.37a15.66 15.66 0 0 0 1.604-2.295h-.003Z",
    fill: "#4C9BCE"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    fill: "#F4F4F4",
    cx: 106,
    cy: 38,
    r: 11
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#5F6363",
    d: "m107 36 3.49-2 3.51 2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#CCC64E",
    d: "M105 36h9v6h-9z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#C4BC4E",
    d: "M98 36h11v6H98z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E0D8D6",
    d: "M98 35h11v1H98zM109 36h5v1h-5z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#5F6363",
    d: "m99 35 4.987-3L109 35z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D6C958",
    d: "M103 36h1v6h-1zM106 36h1v6h-1zM100 36h1v6h-1z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#656666",
    d: "M100 37h2v3h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D1D3D3",
    d: "M100 37h2v3h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#656666",
    d: "M100 37.933h2v1h-2zM106 37h2v3h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D1D3D3",
    d: "M106 37h2v3h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#656666",
    d: "M106 37.933h2v1h-2zM103 37h2v3h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D1D3D3",
    d: "M103 37h2v3h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#656666",
    d: "M103 37.933h2v1h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#9D9E9E",
    d: "M109 41.881h4v1h-4z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#B4B5B5",
    d: "M109 41.881h4v1h-4z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#656666",
    d: "M110 38h2v4h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D1D3D3",
    d: "M110 38h2v2h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M98.55 39.076c4.617-8.071 4.599-17.999-.049-26.054A26.003 26.003 0 0 0 75.999 0C61.64 0 50 11.679 50 26.084a26.037 26.037 0 0 0 3.273 12.676v.008a26.228 26.228 0 0 0 2.38 3.551L75.486 72l20.373-29.083a26.005 26.005 0 0 0 2.69-3.84Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    fill: "#F4F4F4",
    cx: 76,
    cy: 24,
    r: 19
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M89.745 25.238a.467.467 0 0 1-.17-.011 1.635 1.635 0 0 1-.73-.446l-.067-.01a.363.363 0 0 1-.329-.4l-.045-.043c-.276.315-.908.124-.811-.328H64v9h26v-7.717a.493.493 0 0 1-.255-.045Z",
    fill: "#EFB941"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#676A6D",
    d: "M85 17.334 74.14 11l-3.524 2.621L69 14.826 73.842 19l-.022-1.666h.32z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#EFB941",
    d: "M72 18h12v5H72z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E5E7E6",
    d: "M63 32h27v1H63z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#676A6D",
    d: "M83.906 21v3.057L73 24.083V25h17z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E0D8D6",
    d: "M73 24h17v1H73z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFC93E",
    d: "M64 20h10v12H64z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#AF7545",
    d: "M77 19h2v4h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D6D6D6",
    d: "M77 20h2v1h-2zM77 21h2v2h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#AF7545",
    d: "M65 21h2v4h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D6D6D6",
    d: "M65 21h2v1h-2zM65 23h2v2h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#AF7545",
    d: "M68 21h2v4h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D6D6D6",
    d: "M68 21h2v1h-2zM68 23h2v2h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#AF7545",
    d: "M70 21h2v4h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D6D6D6",
    d: "M70 21h2v1h-2zM70 23h2v2h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#AF7545",
    d: "M79 19h2v4h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D6D6D6",
    d: "M79 20h2v1h-2zM79 21h2v2h-2z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#BCBCBC",
    d: "M71.408 32.594v-.31h-.688V32h-4.758v.284h-.368v.31H65V33h7v-.406z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#BC7C48",
    d: "M66 27h4v5h-4z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E0D8D6",
    d: "M64 26h10v1H64zM63 19h11v1H63zM72 17h13v1H72z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#717777",
    d: "m63 19 5.052-4L73 19z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D3D2D1",
    d: "M75 26h13v7H75z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#A0A0A0",
    d: "M76 27h6v2h-6zM82 27h6v2h-6zM82 30h6v2h-6zM76 30h6v2h-6z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#816651",
    d: "M67 28h3v4h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#C1C1C1",
    d: "m0 102.124 29.069-9.398L49 103 29.139 91zM101 104l22.296-12.248L153 102.45 122.363 90z"
  })));
});
var Map = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Map = Map;